const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo3NTEsImNvbmdyZXNzSWQiOjEyMzUsImRhdGUiOiIyMDIxLTA0LTE5VDA2OjQ0OjUyLjAwM1oiLCJpYXQiOjE2MTg4MTQ2OTJ9.c_Zup0gf9KWOoEPFY-Bndxl659nmR4CweGbl2ygKZ9k';
const PLANNER_API_URL = 'https://dbt2021.planner.documedias.systems/api';

// // Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo3NTIsImNvbmdyZXNzSWQiOjEyMzUsImRhdGUiOiIyMDIxLTA0LTE5VDA3OjA4OjQ2LjQzOVoiLCJpYXQiOjE2MTg4MTYxMjZ9.-qHsq7ItE13jcdrOiKHXnzrOcEIjNXddOm-0Ub4WA0w';
// const PLANNER_API_URL = 'http://localhost:8000/api';

const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMC0wNy0wOVQwNzo0MzoxNS4zMjRaIiwiaWQiOjI3MjYzLCJpYXQiOjE1OTQyODA1OTV9.Br6-wpymBvaIbteoz-rjZuzxnuJB9sTOeP0vUgYkTYk';

const CONGRESS_ID = 1235;

// const SUBMISSION_SYSTEM_URL = 'https://dbt2021.abstract.documedias.systems/api/v1/export/transformed/filtered/single/abstract/{{id}}/planner/export';
const SUBMISSION_SYSTEM_URL = 'https://dbt2021.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview'

const SESSION_COLLECTION_ID = 302;

export {
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  PLANNER_API_URL,
  PLANNER_API_KEY,
  CONGRESS_ID,
  SUBMISSION_SYSTEM_URL,
  SESSION_COLLECTION_ID,
}
